module.exports = __webpack_public_path__ + "img/refresh.42c61cdb.svg";